<template>
	<div class="page addons">
		<div class="padded" v-if="activity.AddOnDescription">
			{{ activity.AddOnDescription }}
		</div>
		<div class="deposit_loader center" v-if="loading"><loader /></div>
		<!-- <pre>timeSlotRequirements:{{timeSlotRequirements}}</pre> -->
		<!-- <pre>time.AddOnsSkipped:{{time.AddOnsSkipped}}</pre> -->
		<div class="container" v-if="time && time.AddOns && !loading">
			<add-on-row
				v-for="(addon, i) in addOns"
				:addon="addon"
				:participants="totalParticipants"
				:key="'add-ons-selected-times-addon-' + i"
			/>
		</div>
		<page-header :fixed="true" :undo="true">
			<h3>
				{{
					activity.OverrideAddOnLabel ? activity.AddOnLabel : 'Frequently Added'
				}}
			</h3>
			<template v-slot:undo>
				<div class="back Cancel">
					<a @click.prevent="undo" class="text-blue chevron left" href
						>&nbsp;</a
					>
				</div>
			</template>
		</page-header>

		<page-footer>
			<template v-slot:text>
				<h4 v-if="time && showTime">{{ time.DisplayName }}</h4>
			</template>
			<template v-slot:button>
				<button
					:disabled="addToCartLoading"
					class="button outline"
					:class="{ button_loading: addToCartLoading && skippedLoading }"
					@click.prevent="skipAddOns"
					v-if="!hasRequiredAddOns"
				>
					Skip
				</button>
				<transition name="slide-horizontal">
					<button
						:disabled="addToCartLoading"
						v-if="totalAddOnQuantity || totalAddOnQuantityBackup"
						@click.prevent="done"
						href="#"
						class="button blue ml-1 text-center"
						:class="{
							'scale-animation': totalAddOnQuantity,
							button_loading: addToCartLoading && continueLoading,
						}"
					>
						Continue
					</button>
				</transition>

				<!-- <button
          v-else
          @click.prevent="addToCart"
          href="#"
          :class="{'button_loading':addToCartLoading}"
          class="button blue ml-1 text-center"
        >Add to cart</button>-->
			</template>
		</page-footer>

		<post-add-to-cart-modals
			:addToCartLoading="addToCartLoading"
			:modelErrorsModal="modelErrorsModal"
			@modelErrorsModalOk="modelErrorsModalOk"
			:takenTimesModal="takenTimesModal"
			@takenTimesModalOk="takenTimesModalOk"
			:overlappedActivitiesModal="overlappedActivitiesModal"
			@overlappedActivitiesModalNo="overlappedActivitiesModalNo"
			@overlappedActivitiesModalYes="overlappedActivitiesModalYes"
			:isPackage="
				activeProductDetails.PackageKey &&
					!activeProductDetails.ShowFirstActivityOnly
			"
		/>
	</div>
</template>

<script>
	import PageFooter from '../components/PageFooter.vue';
	import AddOnRow from '../components/AddOnRow.vue';
	import PostAddToCartModals from '../components/PostAddToCartModals.vue';
	import Loader from '../components/Loader.vue';
	import { gzip } from 'node-gzip';
	// mixins
	import addToCart from '../mixins/addToCart.js';
	import postTimeSelection from '../mixins/postTimeSelection.js';

	import { mapGetters, mapMutations, mapState } from 'vuex';

	export default {
		name: 'AddOns',
		props: ['IsLargeGroup'],
		components: {
			Loader,
			PageFooter,
			AddOnRow,
			PostAddToCartModals,
		},
		mixins: [addToCart, postTimeSelection],
		data: function() {
			return {
				backupTime: null,
				skippedLoading: false,
				continueLoading: false,
				loading: false,
			};
		},
		async activated() {
			//alert("activated");
			console.log('addons required?', this.hasRequiredAddOns);
			console.log('AddOns activated', this.activity);
			console.log('Addons Time', this.time);
			this.skippedLoading = false;
			this.continueLoading = false;

			this.backupTime = JSON.parse(JSON.stringify(this.time));

			let el = document.querySelector('.product_details');
			el.scrollTop = 0;
			this.$set(this.time, 'AddOns', this.addOns);
			var payload = {
				OrderEntityKey: this.activity.OrderEntityKey,
				OrderEntityTimeKey: this.time.OrderEntityTimeKey,
				EntityHierarchyKey: this.activity.EntityHierarchyKey,
				AppointmentDate: this.$moment(this.activity.AppointmentDate).format(
					'YYYY-MM-DDTHH:mm:ss'
				),
				PackageKey: this.activity.PackageKey,
				IsPrivateTour: false,
				Rates: this.time.Rates,
				EntityHierarchy: this.activity,
				AddOns: this.activity.AddOns,
				PhotoPackageAddOns: this.activity.PhotoPackageAddOns,
				Time: this.time,
			};
			this.loading = true;
			// console.log("sending",payload)
			// eslint-disable-next-line no-undef
			$.ajax({
				type: 'POST',
				url: this.$store.state.serverPath + '/GetAddOns',
				contentType: 'application/json',
				data: await gzip(JSON.stringify(payload)).then((z) => {
					return z;
				}),
				processData: false,
				headers: {
					'Content-Encoding': 'gzip',
				},
				cache: false,
				success: (json) => {
					this.loading = false;
					this.time = json;
				}, //success
				error: (msg) => {
					this.loading = false;
					console.warn(msg);
				},
				done: function() {
					this.loading = false;
				},
			}); // ajax
		},
		beforeRouteLeave(to, from, next) {
			let pathmatch = /\/\d*\/activity$/;
			if (pathmatch.test(to.path) && window.parent) {
				window.parent.postMessage({ detail_leave: true }, '*');
			}
			next();
		},

		computed: {
			...mapGetters(['activeProductDetails']),
			...mapState(['order']),
			hasRequiredAddOns() {
				// returns if there is at least one required add-on
				return this.addOns.some((addOn) => {
					return addOn.AddOnIsRequired == true;
				});
			},
			totalParticipants() {
				// console.log(this.time.Rates)
				return this.time.Rates.reduce(
					(prev, rate) => rate.Participants + prev,
					0
				);
			},
			// Dynamically calculates what the SubTotal of the Time should be,
			// since GetTimes calculations are unreliable (specifically b/c of Large Groups)
			showTime() {
				return (
					this.activity.AppointmentTypeKey != 2 &&
					this.activity.AppointmentTypeKey != 3
				);
			},
			calculatedSubTotal() {
				var subtotal = 0;
				if (this.time && this.time.Rates) {
					this.time.Rates.forEach((ele) => {
						var itemPrice = ele.Price * ele.Participants;
						if (!isNaN(itemPrice)) {
							subtotal = subtotal + itemPrice;
						}
					});
				}
				return subtotal;
			},
			timeId() {
				return this.$route.params.timeId;
				//return this.$route.params
			},
			modify() {
				return this.$route.params.modify === 'modify';
				//return this.$route.params
			},
			route() {
				return this.$route;
			},
			entityHierarchyKey() {
				return this.$route.params.entityHierarchyKey;
			},
			addOns() {
				return this.time.AddOns;
			},
			totalAddOnQuantity() {
				var i = 0;
				if (this.time && this.time.AddOns) {
					this.time.AddOns.forEach((ele) => {
						//if (!ele.IsBoolean) {
						i = i + ele.Quantity;

						if (ele.Variants) {
							i += ele.Variants.reduce((p, c) => (p += c.Quantity), 0);
						}
						//}
					});
				}
				return i;
			},
			totalAddOnQuantityBackup() {
				var i = 0;
				if (this.backupTime && this.backupTime.AddOns) {
					this.backupTime.AddOns.forEach((ele) => {
						//if (!ele.IsBoolean) {
						i = i + ele.Quantity;
						//}
						if (ele.Variants) {
							i += ele.Variants.reduce((p, c) => (p += c.Quantity), 0);
						}
					});
				}
				return i;
			},

			activity() {
				if (this.activeProductDetails && this.activeProductDetails.Activities) {
					let find = this.activeProductDetails.Activities.find((act) => {
						return (
							act.EntityHierarchyKey * 1 ===
							this.$route.params.entityHierarchyKey * 1
						);
					});
					if (find) {
						return find;
					}
					return {};
				} else {
					return {};
				}
			},
			time: {
				get() {
					if (
						this.activeProductDetails &&
						this.activeProductDetails.Activities
					) {
						// which activity am i on
						let activity = this.activity;
						if (!activity) {
							console.warn('no activity found....');
						}
						// do I have a selected time for this activity

						console.log('addons :>>', activity, activity.TimesClone);
						if (activity && activity.TimesClone) {
							//return activity.TimesClone;
							let s = activity.TimesClone.find((t) => {
								return t.Value * 1 === this.$route.params.timeId * 1;
							});

							if (s) {
								var subtotal = 0;
								s.Rates.forEach((ele) => {
									var itemPrice = ele.Price * ele.Participants;
									if (!isNaN(itemPrice)) {
										subtotal = subtotal + itemPrice;
									}
								});
								s.SubTotal = subtotal;
								return s;
							}
						}
						//
						else {
							console.warn('I need activity.TimesClone');
						}
					}
					return false;
				},
				set(newValue) {
					if (this.activeProductDetails.Activities) {
						// which activity am i on
						// console.log(
						//   "this.activeProductDetails.Activities",
						//   this.activeProductDetails.Activities
						// );
						let activity = this.activity;

						if (!activity) {
							//alert("no activity found....");
						}

						// do I have a selected time for this activity
						if (activity && activity.TimesClone) {
							//return activity.TimesClone;
							let s = activity.TimesClone.find((t) => {
								return t.Value * 1 === this.$route.params.timeId * 1;
							});
							if (s) {
								s.AddOns = JSON.parse(JSON.stringify(newValue.AddOns));
								var subtotal = 0;
								if (s.AddOns) {
									s.AddOns.forEach((ele) => {
										var itemPrice = ele.Price * ele.Participants;
										if (!isNaN(itemPrice)) {
											subtotal = subtotal + itemPrice;
										}
									});
								}
								s.SubTotal = subtotal;
							}
						}
					}
				},
			},
		},

		methods: {
			...mapMutations(['skipAddOnsForTime']),

			done() {
				this.continueLoading = true;
				this.$set(this.time, 'AddOnsSkipped', true);
				this.advancePostTimeSelection('addOns', this.time.Value, this.$route);
				// if (this.IsLargeGroup) {
				//   this.$router.go(-2);
				// } else {
				//   this.$router.go(-1);
				// }
			},
			undo() {
				// when i undo these addons, I may need to also undo the time selection itself
				//

				//alert("hmmm 1 " + this.time.IsSelected);

				// if (!this.modify) {
				//   this.backupTime.IsSelected = false;
				// }

				this.time = this.backupTime;

				//alert("hmmm " + this.time.IsSelected);

				//this.$emit("undoSimpleTimePerhaps", this.timeId);
				setTimeout(() => {
					this.$router.go(-1);
				}, 250);
			},
			skipAddOns() {
				//alert("TO DO : skip addons");

				// revert the state

				//findTime.AddOnsSkipped = true;
				this.skippedLoading = true;

				this.time = this.backupTime;

				this.$set(this.time, 'AddOnsSkipped', true);

				this.advancePostTimeSelection('addOns', this.time.Value, this.$route);

				// this.skipAddOnsForTime({
				//   orderEntityKey: this.activeProductDetails.OrderEntityKey,
				//   orderPackageKey: this.activeProductDetails.OrderPackageKey,
				//   packageKey: this.activeProductDetails.PackageKey,
				//   entityHierarchyKey: this.$route.params.entityHierarchyKey,
				//   timeId: this.time.Value,
				//   callback: () => {
				//     alert("skipped and moving on");
				//     this.time = this.backupTime;
				//     this.advancePostTimeSelection("addOns", this.time.Value, this.$route);
				//   }
				// });
			},
		},
	};
</script>

<style scoped>
	.addons .deposit_loader.center {
		margin-top: 30px;
		position: relative;
	}
	.padded {
		padding: 0px 30px;
	}
</style>
